module.exports = __webpack_public_path__ + "img/client-2.jpg?8e7f6c00192a1b3a41bdc1c46d4d3b62";